<br><app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>SELECCIONAR O CARGAR ARCHIVO</h1>
        </div>
        <div class="row">
            <div class="pagination">
                <div class="flex-container">
                    <app-file-grid [asyncFiles]="asyncFiles"> </app-file-grid>
                </div>
            </div>

            <div class="pagination">
                <pagination-controls
                    previousLabel="Anterior"
                    nextLabel="Siguiente"
                    id="server"
                ></pagination-controls>
            </div>

            <label for="soporte"><b>CARGAR ARCHIVO</b></label>
            <div class="upload-section">
                <div class="file-upload-container">
                    <input
                        name="soporte"
                        id="soporte"
                        class="file-input"
                        type="file"
                        accept=".pdf"
                        (change)="onChangeFile($event)"
                    />
                    <label
                        for="soporte"
                        class="info-creacion"
                        style="color: red"
                    >
                        El archivo debe ser un PDF de máximo 1MB.
                    </label>

                    <button
                        type="button"
                        (click)="closeDialog()"
                        class="secondary-button"
                        id="cancelar"
                    >
                        <span class="button-content"
                            ><mat-icon>close</mat-icon>Cancelar</span
                        >
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
